import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Button, Form } from '_zari/core'

import * as AsientosContablesService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'

import { DownloadAxiosFile } from 'utils'

const CargaDiarioModal = ({ show, handleClose }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      file: ''
    }),
    []
  )

  const parsearYEnviarFormulario = React.useCallback(
    (data, { setSubmitting }) => {
      const submitData = new FormData()
      submitData.append('file', data.file)

      AsientosContablesService.importarCargaDiario(submitData)
        .then(({ data, headers }) => {
          if (data && data.size > 0) {
            DownloadAxiosFile.downloadAsBlob(data, headers)
            __zariContext.snack('success', 'Se han encontrado errores, verificar documento de texto.')
          } else {
            __zariContext.snack('success', 'Proceso de importacion culminado.')
          }
          handleClose()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => setSubmitting(false))
    },
    [__zariContext, handleClose]
  )

  const submitHandler = React.useCallback(
    async (data, { setSubmitting }) => {
      parsearYEnviarFormulario(data, { setSubmitting })
    },
    [parsearYEnviarFormulario]
  )

  return (
    <Modal show={show} size='sm'>
      <Modal.Header>
        <Modal.Title>Importar Asiento Apertura</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, handleSubmit, isSubmitting, touched, setFieldValue, values }) => (
          <Form>
            <Modal.Body>
              <FormGroups.FileFormGroup
                fIsSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
                iError={errors.file}
                iTouched={touched.file}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={handleClose} color='secondary' outline tiny>
                Cerrar
              </Button>
              <Button onClick={handleSubmit} tiny>
                Importar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(CargaDiarioModal)
